export default __webpack_public_path__ + "static/the-graph-logo-text-6cc145d9ec8ec5700c30e10efa261a8a.png";